import { useMediaQuery } from "react-responsive";

export enum DeviceWidth {
  mobile,
  desktop,
}

export const useDeviceWidthQuery = (): DeviceWidth => {
  const result = useMediaQuery({ query: "(min-width: 1180px)" });
  return result ? DeviceWidth.desktop : DeviceWidth.mobile;
};

export const mobileQueryMedia = "@media (max-width: 1179px)";

export const mobileQuery = (
  style: TemplateStringsArray,
): string => `${mobileQueryMedia} { ${style} }`;

export const desktopQueryMedia = "@media (min-width: 1180px)";

export const desktopQuery = (
  style: TemplateStringsArray,
): string => `${desktopQueryMedia} { ${style} }`;
